class Search {
    constructor({ $node }) {
        this.$search = $node;
        this.$form = this.$search.find('.js-search-form');
        this.$input = this.$form.find('.js-search-input');
        this.$close = this.$search.find('.js-search-close');
        this.$triggers = $('.js-search-trigger');
        this.$body = $('body');

        this._wrapper = null;
        this._isOpen = false;
    }

    closeSearch() {
        if(this._wrapper && this._wrapper.length) {
            this._wrapper.append(this.$search);
        }
        this.$body.removeClass('search-is-open');
        this._isOpen = false;
    }

    openSearch() {
        if (!this._wrapper) {
            this._wrapper = this.$search.parent();
        }

        this._isOpen = true;
        this.$body.addClass('search-is-open');
        this.$body.append(this.$search);
        this.$input.focus();
    }

    triggersClickHandler = e => {
        e.preventDefault();

        this._isOpen ? this.closeSearch() : this.openSearch();
    };

    closeClickHandler = e => {
        e.preventDefault();

        if(!this._isOpen) return;

        this.closeSearch();
    };

    formSubmitHandler = () => {
        const url = this.$form.attr('action');
        const value = this.$input.val();

        if(!value.length) return false;

        location.href = `${url}?q=${value}`;

        return false;
    };

    init() {
        if (!this.$form.length) return;

        this.$form.on('submit', this.formSubmitHandler);
        this.$close.on('click', this.closeClickHandler);
        this.$triggers.on('click', this.triggersClickHandler);
    }
}

export default Search;



// WEBPACK FOOTER //
// ./components/search.js